import script from "./MainLogo.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainLogo.vue?vue&type=script&setup=true&lang=ts"

import "./MainLogo.vue?vue&type=style&index=0&id=7e95fa16&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e95fa16"]])

export default __exports__